// extracted by mini-css-extract-plugin
export default {"projectsSection":"ProjectSection_projectsSection__TXNbm"};